import * as React from 'react'

import InfoHint from '~/client/src/shared/components/InfoHint/InfoHint'
import { pictogramSlugOf } from '~/client/src/shared/icons/pictograms'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  iconName: string | null
}

// Sits beside a location's colour label: a library icon paints its own colours, so the colour
// still reaches everything but the icon.
export default function LibraryIconColorHint({
  iconName,
}: IProps): React.ReactElement {
  if (!pictogramSlugOf(iconName)) {
    return null
  }

  const { aboutX, color, iconPicker } = Localization.translator

  return (
    <InfoHint label={aboutX(color)}>{iconPicker.libraryIconColor}</InfoHint>
  )
}
